import React, { useState, useEffect, useRef, useContext } from "react";
import { api } from "@/services/api";
import ShimmerEffect from "@/components/Shimmer";
import Icone from "@/assets/img/Icon feather-chevron-right.svg";
import { Form } from "@unform/web";
import { Scope } from "@unform/core";
import * as Yup from "yup";
import Input from "@/components/Input";
import InputMask from "@/components/InputMask";
import InputSelect from "@/components/inputSelect";
import InputSelectDinamic from "@/components/InputSelectDinamic";
import InputFile from "@/components/InputFile";
import cepPromise from "cep-promise";
import {
	equalTo,
	validateCnpj,
	validadeNewPassword,
	maskPhone
} from "@/utils/validations";
import ModalPopup from "@/components/ModalPopup";
import { Context } from "@/contexts/AuthContext";

import { Container, GroupInput, LabelContainer } from "./styles";

export const PDVProfile = () => {
	const { handleLogout } = useContext(Context);
	const formRef = useRef(null);
	const formImageProfile = useRef(null);
	const [user, setUser] = useState({});
	const [loadData, setLoadData] = useState(false);
	const [formUpdateProfile, setFormUpdateProfile] = useState(false);
	const [updateProfile, setUpdateProfile] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});
	const [formUpdateImageProfile, setFormUpdateImageProfile] = useState(false);
	const [updateImageUser, setUpdateImageUser] = useState(false);
	const [list, setList] = useState(null);
	const [logOut, setLogOut] = useState(false);

	// pegando lista de distribuidores
	useEffect(() => {
		(async () => {
			setLoadData(true);
			const { data } = await api.get("merchant/distributors");
			setList(data);
			setLoadData(false);
			getUser(); // pegando dados do usuario
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function getUser() {
		let user = localStorage.getItem("@profile");
		user = JSON.parse(user);
		setUser(user);
		handleSetFormProfile(user);
	}

	async function handleSubmit(data) {
		Yup.addMethod(Yup.string, "equalTo", equalTo);
		Yup.addMethod(Yup.string, "validadeNewPassword", validadeNewPassword);
		Yup.addMethod(Yup.string, "validateCnpj", validateCnpj);

		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				merchant: Yup.object().shape({
					store: Yup.string().required("Campo obrigatório"),
					manager: Yup.string().required("Campo obrigatório"),
					distributor: Yup.string().required("Campo obrigatório"),
					email: Yup.string()
						.email("E-mail inválido")
						.required("Campo obrigatório"),
					password: Yup.string()
						.optional()
						.validadeNewPassword(
							"A senha deve conter pelo menos 8 caracteres, sendo uma letra maiúscula, uma letra minúscula e um número",
						),
					passwordConfirmation: Yup.string()
						.oneOf([Yup.ref('password'), null], 'As senhas não correspondem'),
					cnpj: Yup.string()
						.validateCnpj("CNPJ inválido")
						.required("Campo obrigatório"),
					phone: Yup.string().required("Campo obrigatório"),
					address_components: Yup.object().shape({
						zip_code: Yup.string().required("Campo obrigatório"),
						address: Yup.string().required("Campo obrigatório"),
						number: Yup.number()
							.typeError("Apenas números")
							.positive("Não pode ser 0 ou valor negativo")
							.integer("Apenas números inteiros")
							.required("Campo obrigatório"),
						district: Yup.string().required("Campo obrigatório"),
						city: Yup.string().required("Campo obrigatório"),
						state: Yup.string().required("Campo obrigatório"),
					}),
				}),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleUpdateProfile(data);
			formRef.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function handleUpdateProfile({ merchant }) {
		setUpdateProfile(true);

		// deletar password se vazio
		// eslint-disable-next-line eqeqeq
		if (merchant.password == false) {
			delete merchant.password;
		}

		api.post("merchant/profile/update", { merchant })
			.then((res) => {
				if (res.status === 200) {
					api.get("merchant/profile")
						.then((response) => {
							localStorage.setItem(
								"@profile",
								JSON.stringify(response.data.merchant),
							);
							getUser();
							setFormUpdateProfile(false);
							setModalContent({
								title: "Programa Fidelidade GERIOOX",
								content: res.data.message,
							});
							setModalPopup(true);
						})
						.catch((error) => {
							console.error({
								endPoint: "merchant/profile",
								error,
							});
						})
						.finally(() => setUpdateProfile(false));
				}
			})
			.catch((error) => {
				console.error({ endPoint: "/merchant/profile/update", error });
			});
	}

	function handleInputComplete() {
		const zip_code = formRef.current.getFieldValue(
			"merchant.address_components.zip_code",
		);
		let value = zip_code.replace(/[-_.]/g, "").length;

		if (value === 8) {
			cepPromise(zip_code.replace(/[-_.]/g, ""))
				.then((res) => {
					formRef.current.setFieldValue(
						"merchant.address_components.address",
						res.street,
					);
					formRef.current.setFieldValue(
						"merchant.address_components.district",
						res.neighborhood,
					);
					formRef.current.setFieldValue(
						"merchant.address_components.city",
						res.city,
					);
					formRef.current.setFieldValue(
						"merchant.address_components.state",
						res.state,
					);
				})
				.catch(console.error);
		}
	}

	// colocando dados no formulario
	function handleSetFormProfile(user) {
		try {
			user.cnpj && formRef.current.setFieldValue("merchant.cnpj", user.cnpj);
			user.distributor && formRef.current.setFieldValue("merchant.distributor", user.distributor);
			user.email && formRef.current.setFieldValue("merchant.email", user.email);
			user.store && formRef.current.setFieldValue("merchant.store", user.store);
			user.manager && formRef.current.setFieldValue("merchant.manager", user.manager);
			user.phone && formRef.current.setFieldValue("merchant.phone", user.phone);
			user.localization.address && formRef.current.setFieldValue(
				"merchant.address_components.address",
				user.localization.address,
			);
			user.localization.city && formRef.current.setFieldValue(
				"merchant.address_components.city",
				user.localization.city,
			);
			user.localization.complement && formRef.current.setFieldValue(
				"merchant.address_components.complement",
				user.localization.complement,
			);
			user.localization.district && formRef.current.setFieldValue(
				"merchant.address_components.district",
				user.localization.district,
			);
			user.localization.number && formRef.current.setFieldValue(
				"merchant.address_components.number",
				user.localization.number,
			);
			user.localization.state && formRef.current.setFieldValue(
				"merchant.address_components.state",
				user.localization.state,
			);
			user.localization.zip_code && formRef.current.setFieldValue(
				"merchant.address_components.zip_code",
				user.localization.zip_code,
			);
		} catch (error) {
			return
		}

	}

	// validacao imagem user
	async function handleSubmitImageProfile(data) {
		const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
		const FILE_SIZE = 500000;

		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				image: Yup.mixed()
					.test(
						"fileSize",
						"A imagem é muito grande. Tamanho máxima 500KB",
						(value) => value.size <= FILE_SIZE,
					)
					.test(
						"fileType",
						"Selecione uma imagem do tipo png ou jpg.",
						(value) => SUPPORTED_FORMATS.includes(value.type),
					)
					.required("Selecione uma imagem."),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			handleUpdateImageUser(data);
			formImageProfile.current.setErrors({});
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formImageProfile.current.setErrors(errorMessages);
			}
		}
	}

	function handleUpdateImageUser({ image }) {
		setUpdateImageUser(true);

		const data = new FormData();
		data.append("photo", image);

		api.post("merchant/profile/photo", data)
			.then((res) => {
				if (res.data.status === 200) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});

					api.get("merchant/profile")
						.then((response) => {
							localStorage.setItem(
								"@profile",
								JSON.stringify(response.data.merchant),
							);
							getUser();
						})
						.catch((error) => {
							console.error({
								endPoint: "merchant/profile",
								error,
							});
						})
						.finally(() => {
							setModalPopup(true);
							setUpdateImageUser(false);
							setFormUpdateImageProfile(false);
						});
				}

				if (res.data.status === 500) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content:
							"Ops! Não foi possível atender sua solicitação.",
					});
				}
			})
			.catch((error) => {
				console.warn({
					endPoint: "merchant/profile/photo",
					error,
				});
			});
	}

	// logOut
	function handleLogoutUser() {
		setLogOut(true);

		api.get("merchant/signout", {
			params: { logout: true },
		})
			.then((res) => {
				handleLogout(`${process.env.PUBLIC_URL}`);
			})
			.catch((error) => {
				console.warn({ endPoint: "consumer/signout", error });
			})
			.finally(() => {
				setLogOut(false);
			});
	}

	return (
		<React.Fragment>
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(false)}
			/>
			<Container>
				<header className='header'>
					<h2>Meu perfil</h2>
					<button
						disabled={logOut ? "disabled" : ""}
						className='d-lg-none'
						onClick={() => handleLogoutUser()}>
						{logOut ? "Saindo..." : "Sair"}
					</button>
				</header>

				<article className='content'>
					<header className='content__header'>
						{/* user-image */}
						<div className='user-image'>
							{loadData ? (
								<ShimmerEffect
									width={100}
									height={100}
									border={50}
								/>
							) : (
								<img
									loading='lazy'
									src={
										user && user.profile_photo
											? `${process.env.REACT_APP_URL_STORE}/${user.profile_photo}`
											: require("@/assets/img/user-default.png")
												.default
									}
									alt='foto de perfil'
								/>
							)}

							<button
								disabled={loadData ? "disabled" : ""}
								className='edite-photo'
								onClick={() => setFormUpdateImageProfile(true)}>
								Trocar Imagem
							</button>
						</div>

						{/* user__info */}
						<div className='user__info'>
							<div className='name'>
								{loadData ? (
									<React.Fragment>
										<ShimmerEffect
											width={60}
											height={20}
											style={{ display: "inline-block" }}
										/>
										<ShimmerEffect
											width={110}
											height={20}
											style={{
												display: "inline-block",
												marginLeft: "10px",
											}}
										/>
									</React.Fragment>
								) : (
									<p>{user?.store}</p>
								)}
							</div>
							<div className='id'>
								{loadData ? (
									<React.Fragment>
										<ShimmerEffect
											width={60}
											height={20}
											style={{ display: "inline-block" }}
										/>
										<ShimmerEffect
											width={180}
											height={20}
											style={{
												display: "inline-block",
												marginLeft: "10px",
											}}
										/>
									</React.Fragment>
								) : (
									<p>CNPJ: {user?.cnpj}</p>
								)}
							</div>
						</div>
					</header>
					{/* informacoes do usuario */}
					<div className='content__body'>
						<table className='table_info'>
							<tbody>
								<tr>
									<td>E-mail</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											user?.email
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Telefone</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											user?.phone
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Endereço</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											<span>
												CEP:{" "}
												{user?.localization?.zip_code}
											</span>
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Distribuidor</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											list?.distributors.filter(
												(el) =>
													el.id === user?.distributor,
											)[0]?.name
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Responsável</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											user?.manager
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
								<tr>
									<td>Senha</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={180}
												height={20}
											/>
										) : (
											"••••••••"
										)}
									</td>
									<td>
										{loadData ? (
											<ShimmerEffect
												width={20}
												height={20}
											/>
										) : (
											<button
												onClick={() =>
													setFormUpdateProfile(true)
												}>
												<img
													loading='lazy'
													src={Icone}
													alt='action'
												/>
											</button>
										)}
									</td>
								</tr>
							</tbody>
						</table>
						<div className='profile-actions'>
							<button
								className='btn-primary'
								disabled={loadData ? "disabled" : ""}
								onClick={() => setFormUpdateProfile(true)}>
								Editar perfil
							</button>
						</div>
					</div>
				</article>

				<article
					style={{ display: formUpdateProfile ? "flex" : "none" }}
					className='popup-form-profile'>
					<div className='popup-form-profile__content'>
						<Form
							ref={formRef}
							name='updateUser'
							onSubmit={handleSubmit}>
							<div>
								<img
									loading='lazy'
									className='close'
									src={
										require("@/assets/img/Icon ionic-ios-close.png")
											.default
									}
									alt='icone close'
									onClick={() => setFormUpdateProfile(false)}
								/>
								<h3>Dados do perfil</h3>
								<Scope path='merchant'>
									<LabelContainer>
										<InputMask
											label='CNPJ*'
											mask='99.999.999/9999-99'
											name='cnpj'
											placeholder='00.000.000/0001-00'
										/>
									</LabelContainer>

									<LabelContainer>
										<Input
											label='Nome da loja*'
											name='store'
											placeholder='Digite o nome da loja'
										/>
									</LabelContainer>

									<LabelContainer>
										<Input
											label='Responsável*'
											name='manager'
											placeholder='Digite o nome completo'
										/>
									</LabelContainer>

									<InputSelectDinamic
										label='Distribuidor'
										name='distributor'
										data={list?.distributors}
									/>

									<LabelContainer>
										<Input
											label='E-mail*'
											name='email'
											placeholder='exemplo@exemplo.com'
										/>
									</LabelContainer>

									<LabelContainer>
										<Input
											label='Nova Senha'
											name='password'
											type='password'
											placeholder='Digite uma senha'
										/>
									</LabelContainer>

									<LabelContainer>
										<Input
											type='password'
											label='Confirmar senha'
											name='passwordConfirmation'
											placeholder='Re-digite sua senha'
										/>
									</LabelContainer>

									<LabelContainer>
										<Input
											type='text'
											label='Telefone*'
											name='phone'
											placeholder='(00) 00000-0000'
											onChange={maskPhone}
											maxLength="15"
										/>
									</LabelContainer>

									<Scope path='address_components'>
										<GroupInput className='flex-center'>
											<LabelContainer>
												<InputMask
													label='CEP*'
													name='zip_code'
													mask='99999-999'
													placeholder='00000-000'
													onChange={
														handleInputComplete
													}
												/>
											</LabelContainer>
											<a
												href='//www.buscacep.correios.com.br/sistemas/buscacep/'
												target='_blank'
												rel='noopener noreferrer'
												className='text-spotlight'>
												Não sei o CEP
											</a>
										</GroupInput>

										<LabelContainer>
											<Input
												label='Endereço*'
												name='address'
												placeholder='Digite seu endereço'
											/>
										</LabelContainer>

										<GroupInput>
											<LabelContainer>
												<Input
													label='Número*'
													name='number'
													placeholder='ex: 1234'
												/>
											</LabelContainer>
											<LabelContainer>
												<Input
													label='Complemento'
													name='complement'
													placeholder='ex: casa, depto, sala'
												/>
											</LabelContainer>
										</GroupInput>

										<LabelContainer>
											<Input
												label='Bairro*'
												name='district'
												placeholder='Digite seu bairro'
											/>
										</LabelContainer>

										<GroupInput>
											<LabelContainer>
												<Input
													label='Cidade*'
													name='city'
													placeholder='Digite sua cidade'
												/>
											</LabelContainer>
											<LabelContainer>
												<InputSelect
													label='Estado*'
													name='state'
												/>
											</LabelContainer>
										</GroupInput>
									</Scope>
								</Scope>
								<p>* Campos obrigatórios.</p>
								<div className='block-submit'>
									<button
										type='submit'
										disabled={
											updateProfile ? "disabled" : ""
										}
										className='btn-primary'>
										{updateProfile
											? "Atualizando cadastro"
											: "Atualizar cadastro"}
									</button>
								</div>
							</div>
						</Form>
					</div>
				</article>

				<article
					style={{
						display: formUpdateImageProfile ? "flex" : "none",
					}}
					className='popup-form-image-profile'>
					<div className='popup-form-image-profile__content'>
						<Form
							ref={formImageProfile}
							name='updateImageProfile'
							onSubmit={handleSubmitImageProfile}>
							<div>
								<img
									loading='lazy'
									className='close'
									src={
										require("@/assets/img/Icon ionic-ios-close.png")
											.default
									}
									alt='icone close'
									onClick={() =>
										setFormUpdateImageProfile(false)
									}
								/>
								<h3>Imagem do perfil</h3>
								<label className='label_image'>
									<div className='button-wrapper'>
										<span className='label'>
											Carregar imagem <span>(Tamanho máxima 500KB)</span>
										</span>
										<InputFile
											name='image'
											id='upload'
											className='upload-box'
											placeholder='Upload File'
											accept='image/png, image/jpeg'
										/>
									</div>
								</label>
								<div className='block-submit'>
									<button
										type='submit'
										disabled={
											updateImageUser ? "disabled" : ""
										}
										className='btn-primary'>
										{updateImageUser
											? "Salvando"
											: "Salvar"}
									</button>
								</div>
							</div>
						</Form>
					</div>
				</article>
			</Container>
		</React.Fragment>
	);
};

export default PDVProfile;
